module.exports = __webpack_public_path__ + "img/artboard0.5f530d24.png";